import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo1 from "../../assets/images/logo1.png";
import logo2 from "../../assets/images/logo2.png";
import { CallOutlined, EmailOutlined } from "@mui/icons-material";
import classes from "./styles.module.scss";
import BIPARD from "../../assets/icon/BIPARD.png";
import training_rule from "../../assets/pdf/Training_Rules.pdf";
import Gad from "../../assets/pdf/GAD_Office_Order_Training.pdf";
import club from "../../assets/pdf/Club.pdf";
import VikBharat from "../../assets/icon/VikBharat.gif";
import vikdata from "../../assets/photo/vikimg.jpeg";
import Hamburger from "../hamburger";
import BipardName from "../../assets/photo/BipardName.svg";
import survey from '../../assets/photo/survey_img.jpg'

const PageHeader = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(null); // Track which dropdown is open
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(null);
  const [isImageOpen, setIsImageOpen] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 140) setIsSticky(true);
      else setIsSticky(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMouseEnter = (menuIndex,submenuIndex) => {
    setIsMenuOpen(menuIndex);
    if (menuIndex === 6 || menuIndex === 7) {
      setIsSubMenuOpen(submenuIndex);
    }
  };

  const handleMouseLeave = () => { 
    if (isSubMenuOpen !== null) return;
    setIsMenuOpen(null);
    setIsSubMenuOpen(null); 
  };

  const handleSubMenuEnter = (submenuIndex) => {
    setIsSubMenuOpen(submenuIndex); 
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const closeImage = () => {
    setIsImageOpen(false);
  };

  useEffect(() => {
    // Automatically show the image modal on the first render
    setIsImageOpen(true);
  }, []); // Empty dependency ensures this runs only once on component mount

  return (
    <div className={classes.first}>
      <div className={classes.top}>
        <h5 id="google_translate_element" style={{ display: "block" }}></h5>
        <div className={classes.contact}>
          <h5>
            <CallOutlined /> 0612-2452585 |
          </h5>
          <h5 className={classes.number}>
            <EmailOutlined /> bipard.gaya-bih@bihar.gov.in
          </h5>
        </div>
      </div>

      <div className={classes.header}>
        <Link to="/">
          <img className={classes.logo1} src={logo1} alt="logo" />
        </Link>
        <div className={classes.headline}>
          <Link to="/">
            <img src={BIPARD} alt="" />
          </Link>
        </div>
        <img className={classes.logo2} src={logo2} alt="logo" />
      </div>

      <Hamburger toggleMenu={() => {}} isMenuOpen={isMenuOpen} />

      {/* {isImageOpen && (
        <div className={classes.lightbox} onClick={closeImage}>
          <img
            src={survey}
            alt="Enlarged"
            className={classes.lightboxImage}
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the image
          />
        </div>
      )} */}

      <div className={`${classes.navcard} ${isSticky ? classes.sticky : ""}`}>
        {/* Sticky logo positioned above the navcard */}
        {isSticky ? (
          <Link to="/">
            <img
              className={`${isSticky ? classes.sticky : ""} ${
                classes.stickyLogo
              }`}
              src={BipardName}
              alt="sticky logo"
            />
          </Link>
        ) : (
          ""
        )}
        <div className={classes.navbar}>
          <Link to="/" onClick={scrollToTop}>
            Home
          </Link>
          <div className={classes.dropdown} onMouseEnter={() => handleMouseEnter(1)} onMouseLeave={handleMouseLeave}>
            <button onClick={scrollToTop}>
              The Academy <i className={`fa fa-chevron-${isMenuOpen === 1 ? "up" : "down"}`}></i>
            </button>
            {isMenuOpen === 1 && (
              <div className={classes.dropcontent}>
                <Link to="/academy/about" onClick={scrollToTop}>
                  About BIPARD
                </Link>
                <Link to="/academy/DGMessage" onClick={scrollToTop}>
                  DG Message
                </Link>
                <div className={classes.dropdownsubmenu} onMouseEnter={() => handleSubMenuEnter(6)} onMouseLeave={handleMouseLeave}>
                  <Link to="#">
                    Governance <i className={`fa fa-chevron-${isSubMenuOpen === 6 ? "right" : "down"}`}></i>
                  </Link>
                  {isSubMenuOpen === 6 && (
                    <div className={classes.dropcontentsubmenu}>
                      <Link to="/academy/governance/generalcouncil" onClick={scrollToTop}>General Council</Link>
                      <Link to="/academy/governance/MoA" onClick={scrollToTop}>MoA</Link>
                    </div>
                  )}
                </div>
                <Link to="/academy/team" onClick={scrollToTop}>
                  Team
                </Link>
                <Link to="/academy/gallery" onClick={scrollToTop}>
                  Gallery
                </Link>
                <Link to="/academy/DGReview" onClick={scrollToTop}>
                  DG Review
                </Link>
                <div className={classes.dropdownsubmenu} onMouseEnter={() => handleSubMenuEnter(7)} onMouseLeave={handleMouseLeave}>
                  <Link to="#">
                    Facilities <i className={`fa fa-chevron-${isSubMenuOpen === 7 ? "right" : "down"}`}></i>
                  </Link>
                  {isSubMenuOpen === 7 && (
                    <div className={classes.dropcontentsubmenu}>
                      <Link to="/academy/facilities/trainingcenter" onClick={scrollToTop}>Training Center</Link>
                      <Link to="/academy/facilities/smartclassroom" onClick={scrollToTop}>Smart Classroom</Link>
                      <Link to="/academy/facilities/computerlab" onClick={scrollToTop}>Computer Lab</Link>
                      <Link to="/academy/facilities/hostel" onClick={scrollToTop}>Hostel</Link>
                      <Link to="/academy/facilities/dinninghall" onClick={scrollToTop}>Dinning Hall</Link>
                      <Link to="/academy/facilities/sports" onClick={scrollToTop}>Sports/Gym</Link>
                      <Link to="/academy/facilities/yoga" onClick={scrollToTop}>Yoga/PT</Link>
                      <Link to="/academy/facilities/healthcare" onClick={scrollToTop}>Health Care</Link>
                    </div>
                  )}
                </div>
                <Link to="/academy/knowledgepartner" onClick={scrollToTop}>
                  Knowledge Partners
                </Link>
              </div>
            )}
          </div>
          <div className={classes.dropdown} onMouseEnter={() => handleMouseEnter(2)} onMouseLeave={handleMouseLeave}>
            <button onClick={scrollToTop}>
              Training <i className={`fa fa-chevron-${isMenuOpen === 2 ? "up" : "down"}`}></i>
            </button>
            {isMenuOpen === 2 && (
              <div className={classes.dropcontent}>
                <Link to="/training/trainingcalendar" onClick={scrollToTop}>
                  Training Calendar
                </Link>
                <Link to="/training/traininghistory" onClick={scrollToTop}>
                  Training History
                </Link>
                <a href={training_rule} target="_blank" rel="noreferrer">
                  Training Rules
                </a>
                <a href={Gad} target="_blank" rel="noreferrer">
                  Training Policies
                </a>
              </div>
            )}
          </div>
          <div className={classes.dropdown} onMouseEnter={() => handleMouseEnter(3)} onMouseLeave={handleMouseLeave}>
            <button onClick={scrollToTop}>
              Publications <i className={`fa fa-chevron-${isMenuOpen === 3 ? "up" : "down"}`}></i>
            </button>
            {isMenuOpen === 3 && (
              <div className={classes.dropcontent}>
                <Link to="/publication/magazine" onClick={scrollToTop}>
                  Magazine
                </Link>
                <Link to="/publication/eBooks" onClick={scrollToTop}>
                  eBooks
                </Link>
                <Link to="/publication/ready-reckoner" onClick={scrollToTop}>
                  Ready Reckoner
                </Link>
              </div>
            )}
          </div>
          <div className={classes.dropdown} onMouseEnter={() => handleMouseEnter(4)} onMouseLeave={handleMouseLeave}>
            <button onClick={scrollToTop}>
              Examinations <i className={`fa fa-chevron-${isMenuOpen === 4 ? "up" : "down"}`}></i>
            </button>
            {isMenuOpen === 4 && (
              <div className={classes.dropcontent}>
                <Link to="/examination/departmentalexam" onClick={scrollToTop}>
                  Departmental Exam
                </Link>
                <Link to="/examination/cctexam" onClick={scrollToTop}>
                  CCT Exam
                </Link>
                <Link to="/examination/otherexam" onClick={scrollToTop}>
                  Other
                </Link>
              </div>
            )}
          </div>
          <div className={classes.dropdown} onMouseEnter={() => handleMouseEnter(5)} onMouseLeave={handleMouseLeave}>
            <button onClick={scrollToTop}>
              Clubs <i className={`fa fa-chevron-${isMenuOpen === 5 ? "up" : "down"}`}></i>
            </button>
            {isMenuOpen === 5 && (
              <div className={classes.dropcontent}>
                <Link to="/clubs/messclub" onClick={scrollToTop}>
                  Mess Club
                </Link>
                <Link to="/clubs/protocolclub" onClick={scrollToTop}>
                  Protocol Club
                </Link>
                <Link to="/clubs/sportsclub" onClick={scrollToTop}>
                  Sport Club
                </Link>
                <Link to="/clubs/sanskriticlub" onClick={scrollToTop}>
                  Sanskriti Club
                </Link>
                <Link to="/clubs/academicclub" onClick={scrollToTop}>
                  Academic Club
                </Link>
                <Link to="/clubs/adventureclub" onClick={scrollToTop}>
                  Adventure & Trekking Club
                </Link>
                <Link to="/clubs/documentationclub" onClick={scrollToTop}>
                  Documentation & I.T Club
                </Link>
                <Link to="/clubs/bharatdarshanclub" onClick={scrollToTop}>
                  Bharat darshan Club
                </Link>
              </div>
            )}
          </div>

          <Link to="/RTI" onClick={scrollToTop}>
            RTI
          </Link>
          <Link to="/visitus" onClick={scrollToTop}>
            Visit Us
          </Link>
        </div>
        <div className={classes.vikshitcardgroup}>
          {/* <div className={classes.vikshitcard}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 48 48"
            >
              <ellipse
                cx="24"
                cy="24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                rx="7.5"
                ry="20.5"
              />
              <ellipse
                cx="24"
                cy="24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                rx="7.5"
                ry="20.5"
                transform="rotate(-60 24 24)"
              />
              <ellipse
                cx="24"
                cy="24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                rx="20.5"
                ry="7.5"
                transform="rotate(-30 24 24)"
              />
            </svg>
            <a href="https://erp.bipard.co.in/citizen-survey/bihar-vision-document" target="_blank" rel="noreferrer">
              Survey Form
            </a>
          </div> */}
          <div className={classes.vikshitcard}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              viewBox="0 0 48 48"
            >
              <ellipse
                cx="24"
                cy="24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                rx="7.5"
                ry="20.5"
              />
              <ellipse
                cx="24"
                cy="24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                rx="7.5"
                ry="20.5"
                transform="rotate(-60 24 24)"
              />
              <ellipse
                cx="24"
                cy="24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                rx="20.5"
                ry="7.5"
                transform="rotate(-30 24 24)"
              />
            </svg>
            <a href="https://bipard.tagbin.in" target="_blank" rel="noreferrer">
              GenNext Lab
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
